/**
 * Mixin para escaneo de códigos de barras con el plugin nativo QRScanner.
 * Usado en tasks/detail.vue y register/detail.vue para la búsqueda por QR.
 *
 * Requiere que el componente implemente:
 * - onQrDecode(barcode): método que procesa el código escaneado
 */
const BARCODE_FORMATS = ['QR_CODE', 'CODE_39', 'CODE_128']

export default {
    data() {
        return {
            qrCounter: 0,
            qrLoading: true,
            qrValue: '',
            backbuttonHandler: null,
            showQrOverlay: false,
            qrScanActive: false
        }
    },
    computed: {
        isApp() {
            return process.env.VUE_APP_IS_APP === 'TRUE'
        },
        currentCamera() {
            return this.$store.getters['getCurrentCamera']
        }
    },
    methods: {
        openQrScanner() {
            if (this.isApp) {
                this.startBarcode()
            } else {
                this.showQrOverlay = true
                this.$nextTick(() => {
                    this.qrScanActive = true
                })
            }
        },
        closeQrOverlay() {
            this.qrScanActive = false
            this.showQrOverlay = false
        },
        startBarcode() {
            this.qrCounter = 0
            this.qrLoading = true
            this.qrValue = ''
            const self = this
            this.$store.commit('setBarcodeActive', true)
            QRScanner.prepare(
                function (err, status) {
                    if (err) {
                        logError(err)
                        self.$store.commit('setBarcodeActive', false)
                        return
                    }
                    if (self.$store.getters['printer/getFirstBackButton']) {
                        self.$store.commit('printer/setFirstBackButton', false)
                        self.backbuttonHandler = function () {
                            self.destroyBarcode()
                        }
                        document.addEventListener('backbutton', self.backbuttonHandler, true)
                    }
                    QRScanner.scan(self.displayContents, { formats: BARCODE_FORMATS })
                    QRScanner.show(function (status) {
                        log(status)
                    })
                    QRScanner.useCamera(self.currentCamera ? self.currentCamera : 0, function (err, status) {
                        log(status)
                    })
                },
                { formats: BARCODE_FORMATS }
            )
        },
        displayContents(err, barcode) {
            if (err) {
                logError(err)
                this.destroyBarcode()
                return
            }
            const self = this
            if (this.qrLoading) {
                this.qrCounter += 1
                if (this.qrCounter === 4) this.qrLoading = false
                QRScanner.scan(self.displayContents, { formats: BARCODE_FORMATS })
            } else {
                if (this.qrValue === barcode) {
                    this.qrCounter += 1
                } else {
                    this.qrValue = barcode
                    this.qrCounter = 1
                }
                if (this.qrCounter < 7) {
                    QRScanner.scan(self.displayContents, { formats: BARCODE_FORMATS })
                } else {
                    this.onQrDecode(barcode)
                    this.destroyBarcode()
                }
            }
        },
        destroyBarcode() {
            this.qrLoading = true
            this.qrCounter = 0
            this.qrValue = ''
            if (this.backbuttonHandler) {
                document.removeEventListener('backbutton', this.backbuttonHandler, true)
                this.backbuttonHandler = null
            }
            if (this.isApp && this.$store.getters.getBarcodeActive) {
                QRScanner.disableLight(function (err, status) {
                    log(status)
                })
                QRScanner.destroy(function (status) {})
            }
            this.$store.commit('setBarcodeActive', false)
        }
    },
    beforeDestroy() {
        this.destroyBarcode()
    }
}
